import { render, staticRenderFns } from "./HiddenLeads.vue?vue&type=template&id=1bd485b6&"
import script from "./HiddenLeads.vue?vue&type=script&lang=js&"
export * from "./HiddenLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports